import axios from "../axiosInstance";
import { IntegrationsStatusResponse } from "./types";

export const getIntegrationsStatus =
  async (): Promise<IntegrationsStatusResponse> => {
    const response = await axios.get<IntegrationsStatusResponse>(
      "/api/private/integration-status",
    );
    return response.data;
  };
